// Core
import styled from 'styled-components';

export const DrawersContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const DrawerContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 0;
`;

export const DrawerHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
`;

export const DrawerBodyContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DrawerFooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
`;
